<!-- article -->
<template>
    <div class="container b-f p-b">
        <div class="article-title">
            <span class="f-32">{{ detail.article_title }}</span>
        </div>
        <div class="article-little dis-flex flex-x-between m-top10">
            <div class="article-little__left">
                <span class="article-divs f-24 col-8">{{ detail.show_views }}次浏览</span>
            </div>
            <div class="article-little__right">
                <span class="article-divs f-24 col-8">{{ detail.view_time }}</span>
            </div>
        </div>
        <div class="article-content m-top20">
            <div class="content" v-html="detail.article_content"></div>
        </div>
        <Tabber ></Tabber>
    </div>
</template>
<script>
    import Tabber from '@/components/Tabber.vue'
    export default {
        name: 'ArticleDetail',
        components: {
            Tabber
        },
        data() { //默认数据
            return {
                // 文章详情
                detail: {},
                article_id: 0, // 文章 ID
            }
        },
        created() { //视图加载前执行
            let _this = this;

        },
        mounted() { //视图加载完成执行
            let _this = this;
            _this.article_id = _this.$route.query.article_id;
            _this.getArticleDetail(_this.article_id);
        },
        methods: { //页面方法
            /**
             * 获取文章详情
             */
            getArticleDetail(article_id) {
                let _this = this;
                _this._get('article/detail', {
                    article_id
                }, function(result) {
                    let detail = result.data.detail;
                    console.log(detail);
                    _this.setData({
                        detail
                    });
                });
            },
        },
        destroyed() {
            let _this = this;
            //切记页面销毁需要销毁
        }
    }
</script>
<style lang="scss">
    @import "detail";
</style>
